<template>
  <section class="page-section hero-page" data-page="0">
    <div class="hero-section">
      <div class="hero-content">
        <!-- <h1 class="hero-title">浙江盛世文脉科技有限公司</h1> -->
        <h1 class="hero-main-title">
          {{ displayedText }}
          <span class="typing-cursor" v-show="isTyping">|</span>
        </h1>
        <div class="hero-description">
          <p>公司拥有顶尖文物数字化技术基因，融合人工智能、大数据、区块链等前沿科技，独家构建遗产文化数据全流程赋能平台。专注于数据科学管理与活化利用，打通学术成果到全场景应用的完整链条，致力成为历史资产价值转化的核心引擎，开创遗产文化数字创新未来。</p>
        </div>
        <!-- <div class="hero-stats">
          <div class="stat-item" v-for="stat in stats" :key="stat.label">
            <div class="stat-number">{{ stat.number }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div> -->
      </div>
      <div class="hero-visual">
        <div class="floating-cards">
          <div 
            class="floating-card" 
            v-for="(card, index) in floatingCards" 
            :key="index" 
            :style="{animationDelay: index * 0.2 + 's'}"
          >
            <div class="card-icon">{{ card.icon }}</div>
            <div class="card-text">{{ card.text }}</div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="scroll-indicator">
      <div class="scroll-arrow">↓</div>
      <span>滚动查看更多</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  data() {
    return {
      fullText: '科技赋能文脉传承，创新驱动文化保护',
      displayedText: '',
      isTyping: true,
      typingSpeed: 150, // 每个字符的显示间隔（毫秒）
      stats: [
        { number: '10+', label: '年技术积累' },
        { number: '100+', label: '成功项目' },
        { number: '50+', label: '合作伙伴' }
      ],
      floatingCards: [
        { icon: '🏛️', text: '文物保护' },
        { icon: '🔬', text: '科技创新' },
        { icon: '🌐', text: '数字化' },
        { icon: '🎨', text: 'IP运营' }
      ]
    };
  },
  mounted() {
    this.startTypingAnimation();
  },
  methods: {
    startTypingAnimation() {
      let index = 0;
      const typeNextChar = () => {
        if (index < this.fullText.length) {
          this.displayedText += this.fullText[index];
          index++;
          setTimeout(typeNextChar, this.typingSpeed);
        } else {
          // 打字完成后，延迟一段时间再隐藏光标
          setTimeout(() => {
            this.isTyping = false;
          }, 1000);
        }
      };
      
      // 延迟开始打字动画
      setTimeout(() => {
        typeNextChar();
      }, 500);
    }
  }
};
</script>

<style scoped>
.hero-page {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 0 20px;
}

.hero-section {
  display: grid;
  grid-template-columns: 800px 300px;
  gap: 60px;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  height: auto;
  justify-content: center;
  margin: 0 auto;
}

.hero-content {
  width: 800px; /* 固定宽度 */
  overflow: visible; /* 允许内容正常显示 */
}

.hero-visual {
  width: 300px; /* 固定宽度 */
}

.hero-main-title {
  font-size: clamp(1.6rem, 3vw, 2.4rem);
  font-weight: 700;
  margin-bottom: 30px;
  background: linear-gradient(135deg, #ffffff 0%, #e0f2fe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.2;
  text-align: left; /* 改为左对齐，与描述文字保持一致 */
  white-space: nowrap;
  overflow: visible;
  min-height: 1.5em;
  width: 100%;
}

.floating-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px; /* 稍微减小间距适应较小宽度 */
  width: 100%;
}

.floating-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 15px; /* 稍微减小内边距 */
  text-align: center;
  animation: float 3s ease-in-out infinite;
  width: 100%;
  box-sizing: border-box;
}

.card-icon {
  font-size: 1.8rem; /* 稍微减小图标 */
  margin-bottom: 8px;
}

.card-text {
  font-size: 0.8rem; /* 稍微减小文字 */
  font-weight: 500;
}

.scroll-indicator {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.8rem;
  animation: bounce 2s infinite;
}

.scroll-arrow {
  font-size: 1.2rem;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% { 
    transform: translateX(-50%) translateY(0); 
  }
  40% { 
    transform: translateX(-50%) translateY(-8px); 
  }
  60% { 
    transform: translateX(-50%) translateY(-4px); 
  }
}

.hero-stats {
  display: flex;
  gap: 40px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 0.9rem;
  opacity: 0.8;
}

.hero-description {
  margin-bottom: 40px;
}

.hero-description p {
  font-size: 1rem;
  line-height: 1.8;
  opacity: 0.85;
  text-align: left; /* 改为左对齐，与标题保持一致 */
  max-width: 600px;
}

.typing-cursor {
  display: inline-block;
  background: linear-gradient(135deg, #ffffff 0%, #e0f2fe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: blink 1s infinite;
  font-weight: 400;
  margin-left: 2px;
  width: 2px; /* 固定光标宽度，防止布局移动 */
  position: relative;
}

@keyframes blink {
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0;
  }
}

/* 通用移动端优化 - 替换现有的媒体查询部分 */
@media (max-width: 1200px) {
  .hero-page {
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .hero-section {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 40px;
    max-width: 100%;
    margin: 0 auto;
    padding: 0 20px;
  }
  
  .hero-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .hero-visual {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  
  .hero-main-title {
    font-size: clamp(1.2rem, 4vw, 2rem);
    white-space: nowrap;
    text-align: center;
    margin-bottom: 25px;
    /* 移除省略效果，完整显示文字 */
  }
  
  .hero-description {
    text-align: center;
    margin-bottom: 30px;
  }
  
  .hero-description p {
    text-align: center;
    font-size: 1rem;
    padding: 0 20px;
  }
  
  .hero-stats {
    justify-content: center;
    gap: 30px;
    margin-bottom: 30px;
  }
  
  .floating-cards {
    justify-content: center;
    margin: 0 auto;
    max-width: 500px;
  }
}

@media (max-width: 768px) {
  .hero-section {
    padding: 0px;
  }
  
  .hero-main-title {
    font-size: clamp(1rem, 5vw, 1.6rem);
    /* 进一步缩小字体以适应屏幕 */
  }
  
  .hero-description p {
    font-size: 0.95rem;
    padding: 0 15px;
  }
  
  .hero-stats {
    gap: 25px;
  }
  
  .floating-cards {
    max-width: 400px;
    gap: 15px;
  }
}
</style>